import './App.css';
import Home from './Sections/Home';

function App() {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
